import styled from 'styled-components';
import breakpoints from '../breakpoints';

export const Carousel = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 40px auto 0 auto;
  position: relative;
  width: 100%;

  @media ${breakpoints.medium} {
    max-width: 690px;
  }

  @media ${breakpoints.large} {
    max-width: 930px;
  }

  @media ${breakpoints.extraLarge} {
    max-width: 1068px;
  }
`;

export const PrevButton = styled.div`
  cursor: pointer;
  display: none;
  left: 0;
  position: absolute;

  @media ${breakpoints.large} {
    display: block;
  }
`;

export const NextButton = styled.div`
  cursor: pointer;
  display: none;
  right: 0;
  position: absolute;

  @media ${breakpoints.large} {
    display: block;
  }
`;

export const ReviewWrapper = styled.div`
  min-height: 220px;
`;

export const DotContainer = styled.div`
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  text-align: center;
`;

export const Dot = styled.div`
  background-color: ${({ active }) => (active ? '#006AFF' : '#D1D1D5')};
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 8px;
  margin-right: 8px;
  width: 8px;

  &:last-child {
    margin-right: 0;
  }
`;
